<div class="section-subtitle fs-32-24 fw-bold" [class.section-subtitle--small]="isSmall">
  <div class="red-square"></div> {{ subtitle }}
</div>
